// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetNoticeOfIntentChangeRequestsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import NoticeOfIntentOptionDTO from '../models/NoticeOfIntentOptionDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    changeRequestId: string | null;
    instsitutionId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            changeRequestId: '00000000-0000-0000-0000-000000000000',
            instsitutionId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    changeRequestId: 'changeRequestId',
    instsitutionId: 'instsitutionId',
}

interface Result extends ResultDTO {
    noticeOfIntents: NoticeOfIntentOptionDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            noticeOfIntents: [],
        },
        initValues);
    },
    noticeOfIntents: 'noticeOfIntents',
}

export { Request, Result };